import { API_BASE } from "@/lib/utils";

let inflight = null;

/** Drop in-memory bootstrap so the next sign-in does not reuse stale tenant data. */
export function clearBootstrapCache() {
  if (typeof window === "undefined") return;
  delete window.__AIVORY_BOOTSTRAP__;
}

/** Cached bootstrap `data` object from the last successful fetch (App or admin shell). */
export function readBootstrapCache() {
  if (typeof window === "undefined") return null;
  const data = window.__AIVORY_BOOTSTRAP__;
  return data && typeof data === "object" ? data : null;
}

/** Single in-flight request shared by App.js and AdminLayout. */
export function loadBootstrapData() {
  const cached = readBootstrapCache();
  if (cached) return Promise.resolve(cached);

  if (!inflight) {
    inflight = fetch(`${API_BASE}/api/bootstrap-data`, { cache: "no-store" })
      .then(async (res) => {
        if (!res.ok) throw new Error(`Bootstrap failed (${res.status})`);
        const payload = await res.json();
        const data = payload?.data || {};
        if (typeof window !== "undefined") {
          window.__AIVORY_BOOTSTRAP__ = data;
        }
        return data;
      })
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
}
